<script>
  // The application bar.
  //
  // Deliberately simpler than the BGO Tool's, which carries a role-aware menu.
  // This app has one shared password and no user accounts, so there is exactly
  // one action: sign out.
  import AppHeader from "./UI/AppHeader.svelte";
  import { confirmAction } from "../lib/confirm.js";

  async function logout() {
    // Confirmed now. It was a solid red btn-error sitting one slip away from
    // the tab strip, and signing out of a shared-password tool means finding
    // whoever knows the password again.
    const ok = await confirmAction({
      title: "Sign out?",
      message: "You will need the shared password to get back in.",
      confirmLabel: "Sign out",
    });
    if (!ok) return;

    // Result deliberately ignored: the server clears the cookie and
    // redirects, and we navigate regardless. Not routed through apiFetch --
    // signing out must work even if the session is already invalid.
    try {
      await fetch("/logout", { method: "POST" });
    } catch {
      // Nothing useful to do; still send the user to the login page.
    }
    window.location.href = "/login";
  }
</script>

<AppHeader title="Dev Tool" badge="Dev">
  <svelte:fragment slot="actions">
    <!-- A tint of --er rather than a solid btn-error. Signing out is
         destructive enough to be marked, not enough to be the loudest thing on
         the page -- which is what the old solid red button was, sitting one
         slip away from the tab strip. -->
    <button
      class="btn btn-sm gap-2 border-0 bg-error/10 normal-case text-error hover:bg-error/20"
      on:click={logout}
    >
      Sign out
      <i class="fas fa-sign-out-alt text-xs" aria-hidden="true"></i>
    </button>
  </svelte:fragment>
</AppHeader>
